/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const leaderboardEntrySchema = z.object({
  rank: z.number().int(),
  nickname: z.string(),
  score: z.number().int(),
  isCurrentUser: z.boolean(),
});

const currentUserSchema = z.object({
  rank: z.number().int(),
  score: z.number().int(),
  nickname: z.string(),
});

export const getLeaderboardResponseDataSchema = z.object({
  entries: z.array(leaderboardEntrySchema),
  currentUser: currentUserSchema,
});

export type IGetLeaderboardResponseData = z.infer<typeof getLeaderboardResponseDataSchema>;

export const getLeaderboardResponseSchema = createApiResponseSchema(
  getLeaderboardResponseDataSchema,
) as z.ZodSchema<IAPI<IGetLeaderboardResponseData>>;

export type IGetLeaderboardResponse = IAPI<IGetLeaderboardResponseData>;
